exports = module.exports = require("../../../../css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".result-list{margin:-5px -5px 0}.record-item{width:112px;position:relative;padding:5px!important;margin:5px 0 0 5px;border:1px solid transparent;border-color:#ddd;border-radius:4px;text-align:center}.record-item.highlighted,.record-item:hover{background-color:#e6e6e6;border-color:#adadad}.record-item.selected-for-download{border-color:red}.record-item a{display:block;height:100px}.record-item img{max-width:100px;max-height:100px;min-height:50px;margin:0;padding:0}.record-item img.fade-in{animation:fadein 1s}@keyframes fadein{0%{opacity:0}to{opacity:1}}.record-item input[type=checkbox]{position:absolute;bottom:10px;right:10px}.record-item button.record-info{position:absolute;top:10px;right:10px;display:none}.record-item:hover button{display:block!important}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// /~/css-loader!/~/postcss-loader!/~/eoxc/src/core/views/RecordItemView.css
// module id = 1972
// module chunks = 0